const tag_en = {
  title: 'Tag',
  addNew: 'Create Tag',
  searchPlaceholder: "Search",
  groupView: 'Group View',
  listView: 'List View',
  showEntries: 'Show entries',
  noData: 'No tags available',
  form: {
    createTitle: 'Create Tag',
    updateTitle: 'Edit Tag',
    name: 'Name',
    namePlaceholder: 'Enter tag name',
    nameRequired: 'Name is required',
    color: 'Color',
    cancel: 'Cancel',
    create: 'Create',
    save: 'Save'
  },
  table: {
    name: 'Name',
    color: 'Color',
    lastChange: 'Last Change',
  },
  message: {
    created: 'Tag was created',
    createError: 'Tag was not created',
    updated: 'Tag was updated',
    updateError: 'Tag was not updated'
  },
  delete: {
    title: 'Delete Tag',
    body: 'Are you sure you want to delete this tag?',
    cancel: 'Cancel',
    delete: 'Delete',
    success: 'Tag was deleted',
    fail: 'Tag delete was failed'
  },
}

export default tag_en
